/* Mega Office Supplies — search UX tweaks
 *
 * Three small corrections to the Searchspring / MR search app, which lives in
 * assets/search-app.js (180KB) and assets/header-search-dropdown.js (1MB). Both are over the
 * themeFilesUpsert limit and cannot be edited, so these are applied after render.
 *
 * 1. Card call-to-action moved below the price
 *    The grid card renders its buttons inside .cgivtozM110gFwwp4Ufp, an absolutely positioned
 *    overlay (inset:0, opacity:0) sitting on top of the product image, revealed only on hover
 *    above 768px. This relocates that block to the end of the card and makes it always
 *    visible, so the card reads image / vendor / title / price / button like the homepage
 *    cards. The card root is a flex column, so appending puts it at the bottom.
 *
 * 2. Product Range and Brand facets open by default
 *    Their facet component is v("div",{class:"zW9tLPczR2Ar9xKLefmK"}, <button>, isOpen &&
 *    <div class="h5WfcE3fR9IVdd3YHY6N">). The panel element only exists while open, which
 *    makes "is it collapsed" an exact test rather than a guess. Collapsed named facets get one
 *    synthetic click on their own toggle button — their state, their handler, no CSS fighting.
 *
 * 3. "View All 10 Results" -> "View All Results"
 *    The dropdown prints its page size, not the total. Searchspring returns 2,326 results for
 *    "pen" over 233 pages while the label claims 10, so the number is simply wrong. Rather
 *    than assert a total this script cannot verify, the number is dropped. The real fix is for
 *    the vendor to use pagination.totalResults.
 *
 * All three are cosmetic, idempotent and fail quiet. Class names are build-generated hashes
 * and will change if the vendor rebuilds the bundle; generic fallbacks are used where
 * practical so a hash change degrades rather than breaks.
 *
 * Debug: add ?searchux=debug to any URL.
 */
(function () {
  'use strict';

  if (window.__mosSearchUx) return;
  var API = (window.__mosSearchUx = { version: 5, ctaMoved: 0, facetsOpened: 0, labelsFixed: 0, labelsLeft: 0, slidersNudged: 0 });

  var CFG = window.mosSearchUxConfig || {};
  var MOVE_CTA = CFG.moveCta !== false;
  var OPEN_FACETS = CFG.openFacets !== false;
  var FIX_LABEL = CFG.fixLabel !== false;
  var PIN_GRID = CFG.pinGrid !== false;
  var FACET_NAMES = (CFG.facetNames || 'Product Range,Brand')
    .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

  var CARD = '.xAV3RRaqDUztoLk9wNZv';
  var OVERLAY = '.cgivtozM110gFwwp4Ufp';
  var FACET = '.zW9tLPczR2Ar9xKLefmK';
  var FACET_BTN = '.yPnDTFlbSMHOsI_alxBs';
  var FACET_PANEL = '.h5WfcE3fR9IVdd3YHY6N';
  var FACET_LABEL = '.gNVdK4aq6avFepFvUUNB';
  var DONE = 'data-mos-ux';
  var DEBUG = location.search.indexOf('searchux=debug') !== -1;

  /* ---------- 1. move the card CTA below the price ---------- */

  function moveCtas() {
    var cards = document.querySelectorAll(CARD + ', a[href*="/products/"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var overlay = card.querySelector(OVERLAY);
      if (!overlay || overlay.getAttribute(DONE) === 'cta') continue;
      // Already the last child? Nothing to do.
      if (card.lastElementChild !== overlay) card.appendChild(overlay);
      overlay.setAttribute(DONE, 'cta');
      card.setAttribute('data-mos-cta-below', '1');
      API.ctaMoved++;
    }
  }

  /* ---------- 2. open named facets ---------- */

  function facetLabel(facet) {
    var span = facet.querySelector(FACET_LABEL);
    var btn = facet.querySelector(FACET_BTN) || facet.querySelector('button');
    var text = (span && span.textContent) || (btn && btn.textContent) || '';
    return text.trim().toLowerCase();
  }

  function openFacets() {
    var facets = document.querySelectorAll(FACET);
    for (var i = 0; i < facets.length; i++) {
      var facet = facets[i];
      if (facet.getAttribute(DONE) === 'facet') continue;      // only ever try once
      var label = facetLabel(facet);
      if (!label) continue;
      var wanted = false;
      for (var j = 0; j < FACET_NAMES.length; j++) {
        if (label.indexOf(FACET_NAMES[j]) !== -1) { wanted = true; break; }
      }
      if (!wanted) continue;

      facet.setAttribute(DONE, 'facet');
      if (facet.querySelector(FACET_PANEL)) continue;          // already open: never re-click
      var btn = facet.querySelector(FACET_BTN) || facet.querySelector('button');
      if (!btn) continue;
      btn.click();
      API.facetsOpened++;
    }
  }

  /* ---------- 3. drop the wrong number from the View All label ---------- */

  var LABEL_RE = /^(\s*view all\s+)([\d,\.]+)(\s+results?\s*)$/i;

  // How many product cards the dropdown is actually showing. Verified selectors from
  // the theme's own buildSsDropdownResultsMarkup() in assets/predictive-search.js.
  function shownCardCount() {
    var n = document.querySelectorAll(
      '.predictive-search__results-list_products > li, ' +
      '.predictive-search__list-item.collection-product-card'
    ).length;
    return n;
  }

  // Targeted, not every a/button/span/div/p on the page. Scanning all of them and reading
  // textContent measured 4ms a pass on a Mega collection page and scaled with page size;
  // this scales with the handful of elements that can actually carry the label.
  var LABEL_SEL = [
    '.predictive-search__view-all',
    '.bottom-search-link a',
    '[class*="seeAll"]',
    '[class*="viewAll"]',
    '[class*="ViewAll"]',
    'a[href*="/search?"]',
    'button[class*="view"]'
  ].join(', ');

  function fixLabels(root) {
    var nodes = (root || document).querySelectorAll(LABEL_SEL);
    var shown = shownCardCount();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;                        // text-only nodes
      if (el.getAttribute(DONE) === 'label') continue;
      var t = el.textContent;
      var m = t ? LABEL_RE.exec(t) : null;
      if (!m) continue;
      // Only drop the number when it cannot be a real total: it is no larger than the
      // handful of cards on screen, i.e. it is the page size being printed as a total.
      // The theme reads pagination.totalResults, which IS correct (2,326 for "pen"), so
      // a number above the card count is left alone rather than thrown away.
      var num = parseInt(String(m[2]).replace(/[,\.]/g, ''), 10);

      // Two kinds of label. Inside the header dropdown the count has always been the page
      // size rather than the total — Searchspring returns 2,322 for "pens" and the button
      // says 10 — so drop it there without further argument. Anywhere else, only drop a
      // number that cannot be a total because it is no larger than what is on screen.
      var inDropdown = !!(el.closest && el.closest(
        '.predictive-search__view-all, .bottom-search-link, .predictive-search__result-group-header'
      )) || (el.className || '').toString().indexOf('predictive-search__view-all') !== -1;

      if (!inDropdown && !(shown > 0 && num > 0 && num <= shown)) {
        el.setAttribute(DONE, 'label');                        // judged correct; never revisit
        API.labelsLeft++;
        continue;
      }
      el.textContent = t.replace(LABEL_RE, '$1$3').replace(/\s+/g, ' ').trim();
      el.setAttribute(DONE, 'label');
      API.labelsFixed++;
    }
  }

  /* ---------- 4. make the dropdown slider re-measure ---------- */

  // initProductsSlider() builds the Swiper with slidesPerView:'auto', so slide widths are
  // read from CSS once at init. If anything is still settling at that moment the widths are
  // wrong and nothing re-reads them, because no resize event follows. update() is Swiper's
  // own re-measure, it is cheap and idempotent, so it is safe to call a few times.
  function nudgeSlider() {
    var sliders = document.querySelectorAll('.predictive-search-products-slider.swiper');
    for (var i = 0; i < sliders.length; i++) {
      var sw = sliders[i].swiper;
      if (!sw || sw.destroyed) continue;
      if (sliders[i].getAttribute(DONE) === 'nudged') continue;
      sliders[i].setAttribute(DONE, 'nudged');
      try { sw.update(); API.slidersNudged++; } catch (e) {}
    }
  }

  /* ---------- run ---------- */

  function apply() {
    try {
      if (MOVE_CTA) moveCtas();
      if (OPEN_FACETS) openFacets();
      if (FIX_LABEL) fixLabels(document);
      if (PIN_GRID) nudgeSlider();
    } catch (e) {
      if (DEBUG) console.warn('[mos-search-ux]', e);
    }
  }

  var timer = null;
  var QUIET = 120;   // collapse a burst of Preact re-renders into a single pass

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
      else apply();
    }, QUIET);
  }

  function start() {
    apply();
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          if (!added) continue;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n && n.nodeType === 1) { schedule(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    [300, 900, 2000, 3500].forEach(function (ms) { setTimeout(schedule, ms); });
    document.addEventListener('input', schedule, true);        // header search typing
    if (DEBUG) readout();
  }

  function readout() {
    setTimeout(function () {
      var el = document.createElement('pre');
      el.style.cssText =
        'position:fixed;z-index:2147483647;bottom:8px;left:8px;margin:0;padding:12px 14px;' +
        'background:#0A3370;color:#FFFFFF;font:12px/1.5 ui-monospace,Menlo,monospace;' +
        'border-radius:10px;white-space:pre;user-select:all;max-width:96vw;' +
        'box-shadow:0 6px 24px rgba(0,0,0,.35)';
      el.textContent = [
        'SEARCH UX  v' + API.version,
        'card CTAs moved below price   ' + API.ctaMoved,
        'facets opened                 ' + API.facetsOpened + '   (' + FACET_NAMES.join(', ') + ')',
        'View All labels corrected     ' + API.labelsFixed,
        'View All labels left alone    ' + API.labelsLeft + '   (number looked like a real total)',
        'dropdown cards on screen      ' + shownCardCount(),
        'dropdown sliders re-measured  ' + API.slidersNudged,
        'cards seen                    ' + document.querySelectorAll(CARD).length,
        'facets seen                   ' + document.querySelectorAll(FACET).length
      ].join('\n');
      document.body.appendChild(el);
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
